export default "https://cdn-static.gokick.com/assets/7e8bc23aa9277111cd73fa77d581d1f801b67d5a/images/spearmint-flavor.b5ab7d3a919e25f2afa45504ef4550ea.png";